module.exports = __webpack_public_path__ + "static/media/discover.dbc401cc.svg";